var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 51,
    viewBox: "0 0 92 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_660_8704)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 88,
    height: 45,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1406 36.1641C51.0078 36.1641 49.5654 35.1182 49.4424 33.4297L49.4355 33.334H50.666L50.6797 33.4297C50.8232 34.4209 51.7803 35.0293 53.209 35.0293C54.6309 35.0293 55.5264 34.3867 55.5264 33.3682V33.3613C55.5264 32.4932 54.959 32.0078 53.6055 31.707L52.5117 31.4678C50.584 31.0439 49.6816 30.1758 49.6816 28.7334V28.7266C49.6885 27.1064 51.124 25.9717 53.1543 25.9717C55.082 25.9717 56.4902 27.0859 56.5996 28.6992L56.6064 28.8018H55.376L55.3623 28.7061C55.2119 27.7012 54.3711 27.1064 53.1201 27.1064C51.8008 27.1133 50.9395 27.7422 50.9395 28.6924V28.6992C50.9395 29.5059 51.5342 30.0117 52.8193 30.292L53.9131 30.5312C55.9365 30.9756 56.7842 31.7959 56.7842 33.2998V33.3066C56.7842 35.0566 55.3965 36.1641 53.1406 36.1641ZM58.1035 36V26.1357H59.293V30.0254H59.3203C59.7031 29.2256 60.4756 28.7539 61.5352 28.7539C63.0459 28.7539 64.0781 29.9229 64.0781 31.6455V36H62.8887V31.8506C62.8887 30.5654 62.2324 29.8066 61.125 29.8066C60.0244 29.8066 59.293 30.6406 59.293 31.8506V36H58.1035ZM67.667 36.1367C66.252 36.1367 65.3018 35.2822 65.3018 33.9902V33.9766C65.3018 32.7666 66.2451 32.0078 67.8789 31.9121L69.916 31.7959V31.2012C69.916 30.333 69.3486 29.8066 68.3574 29.8066C67.4414 29.8066 66.8672 30.2441 66.7305 30.8799L66.7168 30.9414H65.5684L65.5752 30.8662C65.6777 29.6973 66.6963 28.7539 68.3711 28.7539C70.0527 28.7539 71.1055 29.6631 71.1055 31.085V36H69.916V34.8447H69.8887C69.4717 35.624 68.6172 36.1367 67.667 36.1367ZM66.5186 33.9902C66.5186 34.6738 67.0791 35.1045 67.9336 35.1045C69.0547 35.1045 69.916 34.332 69.916 33.2998V32.7188L68.0156 32.835C67.0654 32.8896 66.5186 33.3135 66.5186 33.9766V33.9902ZM72.6162 36V28.8906H73.8057V30.0938H73.833C74.0723 29.2734 74.6875 28.7539 75.4873 28.7539C75.6924 28.7539 75.8701 28.7881 75.9658 28.8018V29.957C75.8701 29.9229 75.6172 29.8887 75.3301 29.8887C74.4072 29.8887 73.8057 30.5312 73.8057 31.6113V36H72.6162ZM79.5205 36.1367C77.4766 36.1367 76.2461 34.708 76.2461 32.4727V32.4658C76.2461 30.2646 77.5039 28.7539 79.4453 28.7539C81.3867 28.7539 82.5693 30.1963 82.5693 32.3291V32.7666H77.4492C77.4766 34.2295 78.2832 35.084 79.5479 35.084C80.4502 35.084 81.0859 34.6328 81.291 34.0244L81.3115 33.9629H82.4805L82.4668 34.0312C82.2344 35.207 81.0723 36.1367 79.5205 36.1367ZM79.4385 29.8066C78.4062 29.8066 77.5996 30.5107 77.4697 31.8369H81.3594C81.2432 30.4561 80.4775 29.8066 79.4385 29.8066Z",
    fill: "#6046FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 87,
    height: 44,
    rx: 5.5,
    stroke: "#6046FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_660_8704",
    x: 0,
    y: 0,
    width: 92,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_660_8704"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.27451 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_660_8704"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_660_8704",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share.843665c3b369deae024cd66e90f3de82.svg";